<div class="flex flex-col">

  <!-- Header -->
  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">{{ entityName }}</h1>
        <p class="text-sm text-gray-500">Total: R$ {{ total | number: '1.2-2' }}</p>
      </div>
      <button (click)="createExpense()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
        Nova Despesa
      </button>
    </div>
  </div>

  <!-- Filtros -->
  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

      <!-- Input de busca -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Buscar</label>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          placeholder="Digite para buscar..."
          class="w-full text-sm"
        />
      </div>

      <!-- Dropdown de status -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Status</label>
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="currentStatus"
          (onChange)="onStatusChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o status"
          class="w-full text-sm"
        ></p-dropdown>
      </div>

      <!-- Dropdown de período -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Período</label>
        <p-dropdown
          [options]="dateRangeOptions"
          [(ngModel)]="currentDateRange"
          (onChange)="onDateRangeChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o período"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
      
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center py-8">
    <p class="text-gray-500">Carregando...</p>
  </div>

  <!-- Tabela -->
  <div *ngIf="!loading" class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="expenses" 
        [paginator]="false"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Código</th>
            <th class="text-left px-6 py-3">Código de Barras</th>
            <th class="text-left px-6 py-3">Parcelas</th>
            <th class="text-left px-6 py-3">Data/Hora</th>
            <th class="text-left px-6 py-3">Total (R$)</th>
            <th class="text-left px-6 py-3">Situação</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        
        <ng-template pTemplate="body" let-item let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ item.id }}</td>
            <td class="px-6 py-2 font-mono">{{ item.code }}</td>
            <td class="px-6 py-2">{{ item.installments }}</td>
            <td class="px-6 py-2">{{ item.dateTime | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="px-6 py-2">R$ {{ item.total | number:'1.2-2' }}</td>
            <td class="px-6 py-2">
              <p-tag
                [value]="item.status"
                [severity]="getStatusSeverity(item.status)"
                [rounded]="false">
              </p-tag>
            </td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Cancelar"
                  icon="pi pi-times"
                  text
                  severity="danger"
                  [disabled]="item.status !== 'pendente'"
                  (click)="cancel(item.id)"
                ></p-button>
                <p-button
                  pTooltip="Imprimir"
                  icon="pi pi-print"
                  text
                  severity="secondary"
                  (click)="print(item.id)"
                ></p-button>
                <p-button
                  [pTooltip]="expanded[item.id] ? 'Ocultar parcelas' : 'Visualizar parcelas'"
                  [icon]="expanded[item.id] ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                  text
                  severity="info"
                  (click)="viewDetails(item.id)"
                ></p-button>
              </div>
            </td>
          </tr>

          <!-- Linha de detalhes/parcelas -->
          <tr *ngIf="expanded[item.id]">
            <td colspan="7" class="px-6 py-3 bg-gray-50">
              <div *ngIf="installmentsLoading[item.id]" class="text-gray-500 py-2">
                Carregando parcelas...
              </div>
              <div *ngIf="!installmentsLoading[item.id]">
                <div *ngIf="(installmentsCache[item.id]?.length || 0) === 0" class="text-gray-500 py-2">
                  Nenhuma parcela encontrada.
                </div>
                <div *ngIf="(installmentsCache[item.id]?.length || 0) > 0" class="overflow-x-auto">
                  <table class="min-w-full text-sm">
                    <thead>
                      <tr class="bg-gray-100">
                        <th class="text-left px-4 py-2">#</th>
                        <th class="text-left px-4 py-2">Código de Barras</th>
                        <th class="text-left px-4 py-2">Vencimento</th>
                        <th class="text-left px-4 py-2">Valor</th>
                        <th class="text-left px-4 py-2">Restante</th>
                        <th class="text-left px-4 py-2">Situação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let inst of installmentsCache[item.id]; let ii = index" [ngClass]="ii % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
                        <td class="px-4 py-2">{{ inst.installment }}</td>
                        <td class="px-4 py-2 font-mono">{{ inst.barCode }}</td>
                        <td class="px-4 py-2">{{ inst.dueDate | date:'dd/MM/yyyy' }}</td>
                        <td class="px-4 py-2">R$ {{ inst.value | number:'1.2-2' }}</td>
                        <td class="px-4 py-2">R$ {{ inst.remainingValue | number:'1.2-2' }}</td>
                         <td class="px-4 py-2">
                           <div class="flex items-center gap-3">
                             <p-tag
                               [value]="inst.canceled ? 'cancelado' : (inst.paid ? 'quitado' : 'pendente')"
                               [severity]="inst.canceled ? 'danger' : (inst.paid ? 'success' : 'warn')"
                               [rounded]="false">
                             </p-tag>
                             <button
                               class="text-green-600 hover:text-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
                               [disabled]="inst.paid || inst.canceled || installmentsLoading[item.id]"
                               (click)="openSettleModal(inst)"
                               pTooltip="Quitar parcela">
                               <i class="pi pi-check"></i>
                             </button>
                           </div>
                         </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
        
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">
              Nenhuma despesa encontrada
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    
    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true">
      </p-paginator>
    </div>
  </div>

</div>

<!-- Modal de quitação -->
<app-modal [(visible)]="settleDialogVisible" header="Quitar parcela">
  <div class="p-4 grid grid-cols-1 md:grid-cols-3 gap-4 overflow-visible">
    <div class="flex flex-col overflow-visible">
      <label class="text-sm font-medium text-gray-700 mb-1">Data</label>
      <input type="date" class="p-inputtext p-component" [(ngModel)]="settleDate" (ngModelChange)="onSettleDateChange()" />
    </div>
    <div class="flex flex-col">
      <label class="text-sm font-medium text-gray-700 mb-1">Tipo de pagamento</label>
      <p-dropdown
        [options]="typePaymentDropdownOptions"
        [(ngModel)]="settleTypePaymentId"
        optionLabel="label"
        optionValue="value"
        placeholder="Selecione"
        class="w-full text-sm"
        appendTo="body"
      ></p-dropdown>
    </div>
    <div class="flex flex-col">
      <label class="text-sm font-medium text-gray-700 mb-1">Valor a pagar</label>
      <input
        type="number"
        class="p-inputtext p-component"
        [(ngModel)]="settleValue"
        (ngModelChange)="onSettleValueChange($event)"
        (input)="enforceSettleInput($event)"
        [min]="getSettleMinPayable()"
        [max]="getSettleMaxPayable()"
        step="0.01"
      />
    </div>
  </div>
  <div *ngIf="settlePreviewLoading" class="px-4 text-sm text-gray-500">Calculando juros...</div>
  <div *ngIf="!settlePreviewLoading && settlePreview" class="px-4 pb-2 grid grid-cols-1 md:grid-cols-4 gap-3 text-sm border-b border-gray-100">
    <div>
      <div class="text-gray-500">Saldo (principal)</div>
      <div class="font-semibold">R$ {{ settlePreview.remainingBefore | number:'1.2-2' }}</div>
    </div>
    <div *ngIf="settlePreview.interestApplied">
      <div class="text-gray-500">Juros nesta quitação</div>
      <div class="font-semibold text-amber-700">R$ {{ settlePreview.interestAmount | number:'1.2-2' }}</div>
    </div>
    <div *ngIf="settlePreview.interestApplied">
      <div class="text-gray-500">Dias em atraso (efetivos)</div>
      <div class="font-semibold">{{ settlePreview.effectiveLateDays }}</div>
    </div>
    <div>
      <div class="text-gray-500">Total sugerido</div>
      <div class="font-semibold text-gray-900">R$ {{ settlePreview.suggestedTotal | number:'1.2-2' }}</div>
    </div>
  </div>
  <div class="px-4 pb-2 grid grid-cols-1 md:grid-cols-5 gap-4">
    <div class="text-sm">
      <div class="text-gray-500">Total da parcela (valor)</div>
      <div class="font-semibold">R$ {{ getSettleOriginalValue() | number:'1.2-2' }}</div>
    </div>
    <div class="text-sm">
      <div class="text-gray-500">Já pago</div>
      <div class="font-semibold text-green-700">R$ {{ getSettlePaidSoFar() | number:'1.2-2' }}</div>
    </div>
    <div class="text-sm">
      <div class="text-gray-500">Restante (atual)</div>
      <div class="font-semibold text-amber-600">R$ {{ getSettleRemainingBefore() | number:'1.2-2' }}</div>
    </div>
    <div class="text-sm">
      <div class="text-gray-500">% restante</div>
      <div class="font-semibold text-blue-700">{{ getSettleRemainingPercent() }}%</div>
    </div>
    <div class="text-sm">
      <div class="text-gray-500">Restará após pagamento</div>
      <div class="font-semibold text-blue-700">R$ {{ getSettleRemainingAfter() | number:'1.2-2' }}</div>
    </div>
  </div>
  <div class="px-4 pb-4 flex justify-end gap-2">
    <button class="p-button p-component p-button-text" (click)="closeSettleModal()">Cancelar</button>
    <button class="p-button p-component p-button-success" [disabled]="settleSubmitting || settlePreviewLoading || !settleTypePaymentId || settleValue == null" (click)="confirmSettle()">
      <span *ngIf="!settleSubmitting">Confirmar</span>
      <span *ngIf="settleSubmitting">Processando...</span>
    </button>
  </div>
</app-modal>

<!-- Modal de confirmação de cancelamento -->
<app-modal [(visible)]="cancelDialogVisible" header="Cancelar lançamento">
  <div class="p-4">
    <p>Tem certeza que deseja cancelar este lançamento?</p>
  </div>
  <div class="px-4 pb-4 flex justify-end gap-2">
    <button class="p-button p-component p-button-text" (click)="closeCancelModal()">Não</button>
    <button class="p-button p-component p-button-danger" [disabled]="cancelSubmitting" (click)="confirmCancel()">
      <span *ngIf="!cancelSubmitting">Sim, cancelar</span>
      <span *ngIf="cancelSubmitting">Cancelando...</span>
    </button>
  </div>
</app-modal>
